import { Item } from "@/types/productTypes";
import { Box, Checkbox, Flex, Text } from "@chakra-ui/react";
import MoreOptions from "../../learnMore/MoreOptions";
import useBreakpoint from "@/hooks/use-breakpoint";
import { useTranslation } from "@/hooks/use-translation";

type CheckboxItemProps = {
   item: Item;
   controlValue: any;
   checkbox: any;
};

export default function CheckboxItem({
   item,
   controlValue,
   checkbox,
}: CheckboxItemProps) {
   const isChecked = controlValue.includes(item.id?.toString());
   const { isMobile } = useBreakpoint();
   const { translate } = useTranslation();
   return (
      <Box
         py={isMobile ? "0.75rem" : "1rem"}
         px={isMobile ? "1rem" : "1.5rem"}
         borderRadius="md"
         border="1px solid"
         borderColor={
            item.disabled
               ? "gray.400"
               : isChecked
                 ? "brandBlue.400"
                 : "gray.300"
         }
         bg={item.disabled ? "gray.100" : "white"}
         transition="all 0.2s ease"
         opacity={item.disabled ? 0.6 : 1} // Greyed-out effect
         cursor={item.disabled ? "not-allowed" : "pointer"}
         pointerEvents={item.disabled ? "none" : "auto"} // Prevents click events when disabled
         _hover={
            item.disabled
               ? {}
               : {
                    borderColor: "brandBlue.300",
                    backgroundColor: "gray.50",
                 }
         }
         _checked={
            item.disabled
               ? {}
               : {
                    borderColor: "brandBlue.400",
                    backgroundColor: "brandBlue.50",
                 }
         }
      >
         <Flex align="center">
            <Checkbox
               {...checkbox}
               isChecked={isChecked}
               isDisabled={item.disabled} // Disable checkbox interaction
               colorScheme="brandBlue"
               fontWeight={isChecked ? 700 : 400}
               color={item.disabled ? "gray.500" : "gray.800"}
               transition="font-weight 0.2s ease"
            >
               <Text fontSize={isMobile ? "0.65rem" : "1rem"}>
                  {translate(item)}
               </Text>
            </Checkbox>
         </Flex>
         {item.more && (
            <Box mt="0.5rem">
               <MoreOptions materials={item.more as string[]} />
            </Box>
         )}
      </Box>
   );
}
